import { useRef } from "react";
import { useSearchParams } from "react-router";
import { formatDate } from "@/utils/format/date-time";
import { FilterForm } from "./clinician-list-filter-form";
import { parseISO } from "date-fns";
import { useForm } from "react-hook-form";

export const ClinicianListFilter = () => {
    // Get form values from URL
    let [searchParams, setSearchParams] = useSearchParams();

    let startDate = searchParams.get("startDate")
        ? parseISO(formatDate(searchParams.get("startDate")))
        : "";

    let endDate = searchParams.get("endDate")
        ? parseISO(formatDate(searchParams.get("endDate")))
        : "";

    const handleDateChange = (date) => {
        setSearchParams((params) => {
            const newParams = new URLSearchParams(params);

            if (date) {
                newParams.set("startDate", formatDate(date[0]));
                newParams.set("endDate", formatDate(date[1]));
            } else {
                newParams.delete("startDate");
                newParams.delete("endDate");
            }

            return newParams;
        });
    };

    const methods = useForm({
        mode: "onChange",
    });

    const addressInputRef = useRef(null);

    const clearSearchParams = () => {
        setSearchParams(new URLSearchParams());
        methods.setValue("findAddress", null);
        addressInputRef.current?.clear();
    };

    const onSubmit = async (data) => {
        if (data === "current-location") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    setGeolocationSearchParams,
                );
            }
            return;
        }

        if (data?.placePrediction) {
            const place = data.placePrediction.toPlace();

            await place.fetchFields({
                fields: ["location"],
            });

            setGeolocationSearchParams({
                latitude: place.location?.lat(),
                longitude: place.location?.lng(),
            });

            return;
        }

        setGeolocationSearchParams(null);
    };

    function setGeolocationSearchParams(position) {
        let latitude;
        let longitude;

        if (position?.coords) {
            latitude = position.coords.latitude;
            longitude = position.coords.longitude;
        } else {
            latitude = position?.latitude;
            longitude = position?.longitude;
        }

        setSearchParams((params) => {
            const newParams = new URLSearchParams(params);

            if (latitude != null && longitude != null) {
                newParams.set("latitude", latitude);
                newParams.set("longitude", longitude);
            } else {
                newParams.delete("latitude");
                newParams.delete("longitude");
            }

            return newParams;
        });
    }

    return (
        <>
            <FilterForm
                methods={methods}
                onSubmit={onSubmit}
                onChange={handleDateChange}
                onClear={clearSearchParams}
                startDate={startDate}
                endDate={endDate}
                ref={addressInputRef}
            />
        </>
    );
};
